<template>
  <v-container>
    <h1>{{ vendor.name }}</h1>

    <AdminBreadcrumbs :vendor="vendor" tail-text="Ordre" />

    <v-card class="orange lighten-5" elevation="3">
      <v-card-title class="white--text orange">
        Ordre

        <v-spacer />

        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Søk"
          single-line
          hide-details
        />
      </v-card-title>

      <v-data-table :headers="headers" :items="orders" :search="search">
        <template v-slot:item.ordered_at="{ item }">
          <router-link
            :to="{
              name: 'adminOrderDetail',
              params: {
                vendorId: vendor.id.toString(),
                orderId: item.id.toString(),
              },
            }"
          >
            {{ item.ordered_at.toLocaleDateString() }}
          </router-link>
        </template>

        <template v-slot:item.paid="{ item }">
          <OrderPaid :paid="item.paid" />
        </template>

        <template v-slot:item.delivered="{ item }">
          <OrderDelivered :delivered="item.delivered" />
        </template>

        <template v-slot:item.payment="{ item }">
          <span style="text-transform: capitalize">{{ item.payment }}</span>
        </template>

        <template v-slot:item.payment_status="{ item }">
          <PaymentStatus :order="item" />
        </template>

        <template v-slot:item.total="{ item }">
          kr {{ item.total }},-
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import OrderPaid from "@/components/OrderPaid.vue";
import OrderDelivered from "@/components/OrderDelivered.vue";
import PaymentStatus from "@/components/PaymentStatus";
import AdminBreadcrumbs from "@/components/AdminBreadcrumbs";
import backend from "@/backend";

export default {
  name: "AdminOrders",

  components: {
    OrderPaid,
    OrderDelivered,
    PaymentStatus,
    AdminBreadcrumbs,
  },

  props: {
    vendorId: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    vendor: {},
    orders: [],
    search: "",
    headers: [
      {
        text: "Dato",
        value: "ordered_at",
      },
      {
        text: "Ordrenummer",
        value: "order_number",
      },
      {
        text: "Navn",
        value: "name",
      },
      {
        text: "Beløp",
        value: "total",
      },
      {
        text: "Betalingsmåte",
        value: "payment",
      },
      {
        text: "Betaling",
        value: "payment_status",
      },
      {
        text: "Levert",
        value: "delivered",
      },
    ],
  }),

  async created() {
    this.vendor = await backend.get(`vendors/${this.vendorId}/`);

    const ordersData = await backend.get("orders/", {
      vendor: this.vendorId,
    });

    this.orders = ordersData.map((x) => {
      x["ordered_at"] = new Date(x["ordered_at"]);
      return x;
    });
  },

  methods: {
    getPaidLabel(paid) {
      return paid ? "Ja" : "Nei";
    },

    getPaidColor(paid) {
      return paid ? "green" : "red";
    },

    getStatusLabel(stat) {
      if (stat == "New") {
        return "Ny";
      }
      if (stat == "Completed") {
        return "Fullført";
      }
    },

    getStatusColor(stat) {
      if (stat == "New") {
        return "yellow";
      }
      if (stat == "Completed") {
        return "green";
      }
    },
  },
};
</script>
